import { use, useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { Pages } from '../../../common/src/pages.ts';
import { PrimaryOrgHymnalName } from '../../../common/src/paths.ts';
import { useCurrentOrg } from '../data/use_current_org.tsx';
import { HymnalsContext } from '../data/use_hymnals.tsx';
import { useUserAttributes } from '../data/use_user_attributes.ts';
import { EditButtonContextProvider } from '../util/edit_song.tsx';
import { getUrlForPage, PrimaryOrgHymnalId } from '../util/path.ts';
import { HymnsList } from '../views/hymns_list.tsx';

export function OrgHymnalPage() {
  const { currentOrg } = useCurrentOrg();
  const allHymnals = use(HymnalsContext);
  const navigate = useNavigate();
  const { isInternalUser, isOrgAdmin } = useUserAttributes();
  const [isInSongEditMode, setIsInSongEditMode] = useState(false);

  const churchHymnalWithHiddenSongs =
    currentOrg && !currentOrg.notInterested
      ? allHymnals?.find((hymnal) => hymnal.id === PrimaryOrgHymnalId)
      : undefined;
  const churchHymnal = churchHymnalWithHiddenSongs && {
    ...churchHymnalWithHiddenSongs,
    hymns: churchHymnalWithHiddenSongs.hymns.filter(
      ({ slug }) => isInSongEditMode || !currentOrg?.hiddenSongs?.includes(slug),
    ),
  };

  const primaryHymnalIds = currentOrg?.primaryHymnalIds;
  const primaryHymnals = primaryHymnalIds && allHymnals?.filter((hymnal) => primaryHymnalIds.includes(hymnal.id));

  const onEditClick = useCallback(() => {
    setIsInSongEditMode(!isInSongEditMode);
  }, [isInSongEditMode]);

  const onClose = useCallback(async () => {
    await navigate(getUrlForPage(Pages.Organization));
  }, [navigate]);

  return churchHymnal ? (
    <EditButtonContextProvider>
      <HymnsList
        hymnals={allHymnals}
        title={
          <TitleWrapper>
            <Title>
              {PrimaryOrgHymnalName +
                (churchHymnal && primaryHymnals && primaryHymnals.length !== 1
                  ? ` (${churchHymnal.hymns.length})`
                  : '')}
            </Title>
          </TitleWrapper>
        }
        weeklySongGroups={[
          ...(primaryHymnals && primaryHymnals.length > 1 ? primaryHymnals : []),
          ...(churchHymnal ? [churchHymnal] : []),
        ]}
        areTopHymnalsFancy={!!primaryHymnals && primaryHymnals.length > 1}
        onClose={onClose}
        onHeaderEditClick={isInternalUser || isOrgAdmin ? onEditClick : undefined}
        isInSongEditMode={isInSongEditMode}
        isUploadSongButtonVisible={true}
      />
    </EditButtonContextProvider>
  ) : null;
}

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
`;
const Title = styled.div``;
